import { Box, Skeleton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useInvestFunds from '../hooks/fund/useInvestFunds';
import investmentFundLang from '../langs/investmentFundLang';

type CGraphNoFundProps = {
	height: number;
	variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
};

const CGraphNoFund = (props: CGraphNoFundProps) => {
	const { height, variant } = props;

	const { funds } = useInvestFunds();
	const { t } = useTranslation();

	return (
		<>
			{funds ? (
				<Box
					sx={{
						position: 'relative',
						width: variant === 'rectangular' ? '100%' : height + 'px',
						margin: 'auto',
					}}
				>
					<Skeleton
						animation={false}
						variant={variant ?? 'circular'}
						width="100%"
						height={height}
						sx={{
							backgroundColor: 'rgba(150,150,150,0.1)',

							margin: '10px auto 10px auto',
						}}
					/>
					<Box
						sx={{
							position: 'absolute',
							textAlign: 'center',
							width: '100%',
							padding: '30px',
							top: '50%',
							transform: 'translateY(-50%)',
						}}
					>
						{funds.length === 0 ? (
							<>{t(investmentFundLang.text_no_graph_when_no_fund.tag)}</>
						) : (
							<>{t(investmentFundLang.text_no_graph_when_investments_only_in_liquidated_funds.tag)}</>
						)}
					</Box>
				</Box>
			) : (
				<></>
			)}
		</>
	);
};

export default CGraphNoFund;
